import React, { memo, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import useProductPageContent from '../../hooks/useProductPageContent';


const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});


const ProductListHotDeals = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = useProductPageContent();
    // const [dataProduct, setDataProduct] = React.useState([]);


    const formatPercentageDiscount = (discount, price) => {
        const percentage = ((price - discount) / price) * 100;
        return percentage.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    // useEffect(() => {
    //     if (status === 'idle') {
    //         fetchPageContent({ type: "home", field: 'Product' });
    //     }

    //     if (status === 'done') {
    //         //console.log(data);
    //         setDataProduct(data);
    //     }
    //     // console.log(data);
    //     // console.log(status);
    // }, [status])

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };
    return (
        <div className="hot-deals-slider arrow-style-two">
            {/* {
                dataProduct.length > 0 && ( */}
                    <Slider {...settings}>
<div key={1} className='brandpicture'>
                                <img src='/assets/images/brand_temp/cocacola.png?width=128'></img>
                            </div>

<div key={2} className='brandpicture'>
                                <img src='/assets/images/brand_temp/danone.png?width=128'></img>
                            </div>

                            <div key={3} className='brandpicture'>
                                <img src='/assets/images/brand_temp/delfi.jpg?width=128'></img>
                            </div>

<div key={4} className='brandpicture'>
                                <img src='/assets/images/brand_temp/indofood.jpg?width=128'></img>
                            </div>

                            <div key={5} className='brandpicture'>
                                <img src='/assets/images/brand_temp/kelloggs.jpg?width=128'></img>
                            </div>

<div key={6} className='brandpicture'>
                                <img src='/assets/images/brand_temp/lays.png?width=128'></img>
                            </div>
                        {
                            

                            // dataProduct.map((item, index) => (
                            //     <div key={index} style={{ minHeight: "100%" }}>
                            //         <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2" style={{ minWidth: "255px" }}>
                            //             <div className='w-100'>
                            //                 {item?.discountPrice > 0 &&
                            //                     item?.discountPrice < item?.price && (
                            //                         <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                            //                             Sale{" "}
                            //                             {Number(item?.discount)
                            //                                 ?.toFixed(0)
                            //                                 ?.toLocaleString("en-US")}
                            //                             %
                            //                         </span>
                            //                     )}
                            //                 <Link
                            //                     to={`/product-details/${encodeURIComponent(item?.slug)}`}
                            //                     className="product-card__thumb flex-center"
                            //                 >
                            //                     <img
                            //                         src={
                            //                             item.photoData && item.photoData.length > 0
                            //                                 ? item.photoData[0].url
                            //                                 : "/assets/images/no-image.png"
                            //                         }
                            //                         alt=""
                            //                     // className="w-auto max-w-unset"
                            //                     />
                            //                 </Link>
                            //             </div>

                            //             <div className="product-card__content p-sm-2" style={{ minWidth: "100%" }}>
                            //                 <h6 className="title text-lg fw-semibold mt-12 mb-8">
                            //                     <Link to="/product-details" className="link text-line-2">
                            //                         {item.name}
                            //                     </Link>
                            //                 </h6>
                            //                 {/* <div className="flex-align gap-4">
                            //                     <span className="text-main-600 text-md d-flex">
                            //                         <i className="ph-fill ph-storefront" />
                            //                     </span>
                            //                     <span className="text-gray-500 text-xs">
                            //                         By Lucky Supermarket
                            //                     </span>
                            //                 </div> */}
                            //                 <div className="product-card__content mt-12">
                            //                     <div className="product-card__price mb-8">
                            //                         <span className="text-heading text-md fw-semibold ">
                            //                             {"$"}
                            //                             {
                            //                                 item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                            //                                     item.discountPrice
                            //                                 ) : (
                            //                                     item.price
                            //                                 )
                            //                             }
                            //                             {" "}
                            //                             <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                            //                         </span>
                            //                         {
                            //                             (item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "") && (
                            //                                 <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                            //                                     {"$"}
                            //                                     {
                            //                                         item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                            //                                             item.price
                            //                                         ) : (
                            //                                             item.discountPrice
                            //                                         )
                            //                                     }
                            //                                 </span>
                            //                             )
                            //                         }

                            //                     </div>
                            //                     <div className="flex-align gap-6">
                            //                         <span className="text-xs fw-bold text-gray-600">4.8</span>
                            //                         <span className="text-15 fw-bold text-warning-600 d-flex">
                            //                             <i className="ph-fill ph-star" />
                            //                         </span>
                            //                         <span className="text-xs fw-bold text-gray-600">(17k)</span>
                            //                     </div>
                            //                     <Link
                            //                         to="/cart"
                            //                         className="product-card__cart btn bg-main-one-50 text-main-one-600 hover-bg-main-one-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                            //                     >
                            //                         Add To Cart <i className="ph ph-shopping-cart" />
                            //                     </Link>
                            //                 </div>
                            //             </div>
                            //         </div>
                            //     </div>
                            // ))
                        }
                    </Slider>
                {/* )
            } */}
            
        </div>

    )
}

export default ProductListHotDeals